var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProcess01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_217_1404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6152 57.5L73.1152 75C77.1377 79.0225 78.1152 77.5 78.1152 75V5C78.1152 3.6175 76.9977 2.5 75.6152 2.5H5.61523C4.23273 2.5 3.11523 3.6175 3.11523 5V60C3.11523 61.3825 4.23273 62.5 5.61523 62.5H50.6152",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8153 32.3996C57.8153 30.8512 56.5637 29.5996 55.0153 29.5996C53.4669 29.5996 52.2153 30.8512 52.2153 32.3996C52.2153 33.948 53.4669 35.1996 55.0153 35.1996C56.5637 35.1996 57.8153 33.948 57.8153 32.3996Z",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8153 32.3996C42.8153 30.8512 41.5637 29.5996 40.0153 29.5996C38.4669 29.5996 37.2153 30.8512 37.2153 32.3996C37.2153 33.948 38.4669 35.1996 40.0153 35.1996C41.5637 35.1996 42.8153 33.948 42.8153 32.3996Z",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8153 32.3996C27.8153 30.8512 26.5637 29.5996 25.0153 29.5996C23.4669 29.5996 22.2153 30.8512 22.2153 32.3996C22.2153 33.948 23.4669 35.1996 25.0153 35.1996C26.5637 35.1996 27.8153 33.948 27.8153 32.3996Z",
    stroke: "#222222",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_217_1404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.615234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcess01);
export default __webpack_public_path__ + "static/media/icon_process_01.bc62f3bc1425842a163cd7ab20eb1907.svg";
export { ForwardRef as ReactComponent };